// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".B0k9M{display:block}.Eoj2h{padding:24px 0;border-top:1px solid #e2e2e2}@media screen and (min-width:768px){.Eoj2h{border:0}}@media screen and (min-width:768px){.Eoj2h+.Eoj2h{border-top:1px solid #e2e2e2}}.Eoj2h>:first-child{width:50%;height:20px}.Eoj2h>:last-child{height:72px;margin-top:12px}@media screen and (min-width:768px){.Eoj2h>:last-child{height:48px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "B0k9M",
	"lines": "Eoj2h"
};
module.exports = ___CSS_LOADER_EXPORT___;
